import { render } from "./mini-Loader.vue?vue&type=template&id=3902c7bf&scoped=true"
import script from "./mini-Loader.vue?vue&type=script&lang=js"
export * from "./mini-Loader.vue?vue&type=script&lang=js"

import "./mini-Loader.vue?vue&type=style&index=0&id=3902c7bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3902c7bf"]])

export default __exports__